import { defineMessages } from 'react-intl';

export default defineMessages({
  accessLevelLabel: {
    id: 'frontbucket.repository.details.accessLevelLabel',
    description:
      'Label for the privilege or access level the current user has for a repository',
    defaultMessage: 'Access level',
  },
  branchesCountLabel: {
    id: 'frontbucket.repository.details.branchesCountLabel',
    description: 'Label for the number of branches a repository has',
    defaultMessage: 'Branches',
  },
  branchesCountAriaLabel: {
    id: 'frontbucket.repository.details.branchesCountAriaLabel',
    description: 'Aria label for the number of branches a repository has',
    defaultMessage:
      '{count, plural, one {{count} branch} other {{count} branches}}',
  },
  cardLabel: {
    id: 'frontbucket.repository.details.cardLabel',
    description: 'Header for the repository details sidebar panel',
    defaultMessage: 'Repository details',
  },
  forksCountLabel: {
    id: 'frontbucket.repository.details.forksCountLabel',
    description: 'Label for the number of forks a repository has',
    defaultMessage: 'Forks',
  },
  forksCountLabelWithValue: {
    id: 'frontbucket.repository.details.forksCountLabelWithValue',
    description: 'Heading for the number of forks a repository has',
    defaultMessage: '{count, plural, one {{count} Fork} other {{count} Forks}}',
  },
  forksCountAriaLabel: {
    id: 'frontbucket.repository.details.forksCountAriaLabel',
    description: 'Aria label for the number of forks a repository has',
    defaultMessage:
      'Open modal: {count, plural, one {{count} fork} other {{count} forks}}',
  },
  forkOfLabel: {
    id: 'frontbucket.repository.details.forkOfLabel',
    description:
      'Label for the parent repository, if this repository is a fork',
    defaultMessage: 'Fork of',
  },
  languageLabel: {
    id: 'frontbucket.repository.details.languageLabel',
    description: 'Label for the programming language set for the repository',
    defaultMessage: 'Language',
  },
  lastUpdatedLabel: {
    id: 'frontbucket.repository.details.lastUpdatedLabel',
    description:
      'Label for the date representing the last time a repository was updated',
    defaultMessage: 'Last updated',
  },
  openPullRequestsCountLabel: {
    id: 'frontbucket.repository.details.openPullRequestsCountLabel',
    description: 'Label for the number of open pull requests a repository has',
    defaultMessage: 'Open pull requests',
  },
  openPullRequestsAriaLabel: {
    id: 'frontbucket.repository.details.openPullRequestsCountAriaLabel',
    description:
      'Aria label for the number of open pull requests a repository has',
    defaultMessage:
      '{count, plural, one {{count} open pull request} other {{count} open pull requests}}',
  },
  privilegeAdmin: {
    id: 'frontbucket.repository.details.adminPrivilegeLabel',
    description: 'Name for the "Admin" repository privilege',
    defaultMessage: 'Admin',
  },
  privilegeRead: {
    id: 'frontbucket.repository.details.readPrivilegeLabel',
    description: 'Name for the "Read" repository privilege',
    defaultMessage: 'Read',
  },
  privilegeWrite: {
    id: 'frontbucket.repository.details.writePrivilegeLabel',
    description: 'Name for the "Write" repository privilege',
    defaultMessage: 'Write',
  },
  sizeLabel: {
    id: 'frontbucket.repository.details.sizeLabel',
    description: 'Label for repository size',
    defaultMessage: 'Repository size',
  },
  syncButton: {
    id: 'frontbucket.repository.details.syncButton',
    description: 'Button that syncs a repository fork with its parent',
    defaultMessage:
      '{commitsBehind, plural, one {Sync ({commitsBehind} commit behind)} other {Sync ({commitsBehind} commits behind)}}',
  },
  watchersCountLabel: {
    id: 'frontbucket.repository.details.watchersCountLabel',
    description: 'Label for the number of watchers a repository has',
    defaultMessage: 'Watchers',
  },
  watchersCountLabelWithValue: {
    id: 'frontbucket.repository.details.watchersCountLabelWithValue',
    description: 'Heading for the number of watchers a repository has',
    defaultMessage:
      '{count, plural, one {{count} Watcher} other {{count} Watchers}}',
  },
  watchersCountAriaLabel: {
    id: 'frontbucket.repository.details.watchersCountAriaLabel',
    description: 'Aria label for the number of watchers a repository has',
    defaultMessage:
      '{count, plural, one {{count} watcher} other {{count} watchers}}, open the modal',
  },
  websiteLabel: {
    id: 'frontbucket.repository.details.websiteLabel',
    description: 'Label for the website set for a repository',
    defaultMessage: 'Website',
  },
  errorHeading: {
    id: 'frontbucket.repository.details.error.heading',
    description:
      'Text for error state showing that there was a problem loading the details card',
    defaultMessage: `Couldn't load details`,
  },
  errorAction: {
    id: 'frontbucket.repository.details.error.action',
    description:
      'Click action for error state showing that there was a problem loading the details card',
    defaultMessage: 'Try again',
  },
});
